import apiBase from "@/api/unversioned/apiBase";
import { PerformanceDataRequestPayload, TimelineDataRequestPayload } from "@/views/CarrierPerformanceView/types";
import { type AxiosRequestConfig } from "axios";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/carrier-performance/query`;

const transitQuery = (
  endpoint: string,
  payload: PerformanceDataRequestPayload | TimelineDataRequestPayload,
  config?: AxiosRequestConfig
) => {
  const queryString = new URLSearchParams(
    Object.entries(payload)
      .filter(([, value]) => value !== undefined && value !== null)
      .flatMap(([key, value]) => (Array.isArray(value) ? value.map((v) => [key, String(v)]) : [[key, String(value)]]))
  ).toString();

  return apiBase("get", `${baseURL}/transit/${endpoint}?${queryString}`, config);
};

const transitPerformanceByCarrier = (payload: PerformanceDataRequestPayload, config?: AxiosRequestConfig) =>
  transitQuery("carrier", payload, config);

const transitPerformanceByLane = (payload: PerformanceDataRequestPayload, config?: AxiosRequestConfig) =>
  transitQuery("lane", payload, config);

const transitTimeline = (payload: TimelineDataRequestPayload, config?: AxiosRequestConfig) =>
  transitQuery("timeline", payload, config);

export { transitPerformanceByCarrier, transitPerformanceByLane, transitTimeline };
